<template>
  <div>
    <v-card class="ma-0">
      <v-card-title class="headline mb-5">
        <template v-if="content && content.length > 0">
          <template v-for="(item, index) in content">
            <h3 v-if="item.type === 'title' && item.text" :key="index" v-html="item.text"></h3>
          </template>
        </template>
      </v-card-title>

      <v-card-text>
        <template v-if="content && content[1]">
          <p v-if="(content[1].type === 'text' && content[1].text)">
            <pre v-html="content[1].text"></pre>
          </p>
        </template>
        <v-textarea
          v-model="question"
          outlined
          :label="$t('ask-help.modal.label-1')"
        ></v-textarea>

        <template v-if="content && content[2]">
          <p v-if="(content[2].type === 'text' && content[2].text)" class="mb-0">
            <pre v-html="content[2].text"></pre>
          </p>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-layout>
          <v-file-input
            v-model="attach"
            :label="$t('ask-help.modal.attach-label')"
            prepend-inner-icon="icon-document files-icon"
            prepend-icon=""
            clear-icon="icon-delete delete-icon"
            clearable
            multiple
            outlined
            accept="application/vnd.sealed.doc,.doc,.docx, application/pdf,.pdf, application/vnd.sealed.xls,.xls,.xlsx, application/vnd.sealed.ppt,.ppt,.pptx, image/jpg, image/jpeg, image/png, image/bmp, image/gif, image/tiff, audio/mpeg3, .mp3, .wav, video/mp4, video/mpeg,.mpeg, .avi, video/vnd.sealedmedia.softseal.mov,.mov, 	application/zip, application/vnd.rar,.rar, application/gzip,.gz"
          ></v-file-input>

          <v-spacer></v-spacer>

          <v-btn
            outlined
            rounded
            color="primary"
            @click="AskAQuestion"
          >
            {{ $t('ask-help.modal.btn-1') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { askQuestion } from '@/js/questions/askQuestion'
import { getStatic } from '@/js/static/getStatic'

export default {
  props: {
    keywords: String,
    page: String,
    context: String
  },

  data () {
    return {
      question: null,
      attach: null,
      content: null
      // keyword: null,
      // page: null
    }
  },

  created () {
    // if (this.$store.getters['auth/isAuthenticated!']) return

    const params = {
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      keyword: 'askbox'
    }
    getStatic(params)
      .then(response => { this.content = response.modules })
      // .catch(() => {
      //   this.httpalert = true
      //   setTimeout(() => {
      //     this.httpalert = false
      //   }, 4000)
      // })
  },

  methods: {
    AskAQuestion () {
      if (!this.$store.getters['auth/isAuthenticated']) {
        this.$emit('dialogToParent', false)
        this.question = null
        this.attach = null
        // return
      } else { // test question from: to delete -2* audit, frcl
        const params = {
          attach: this.attach,
          keywords: this.keywords,
          lang: this.$i18n.locale ? this.$i18n.locale : 'en',
          page: this.page,
          question: this.question,
          context: this.context,
          key: this.$store.state.auth.token
        }
        askQuestion(params)
          .then(response => {
            this.$emit('alert', response)
            // reset modal
            this.$emit('dialogToParent', false)
            this.question = null
            this.attach = null
          })
          .catch(() => {
            this.$emit('alert', {
              alert: true,
              alertType: 'error',
              alertMessage: this.$t('ask-help.modal.error-message')
            })
          })
      }
    }
  }
}
</script>
